export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=37e8aa54&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/index.vue?vue&type=template&id=37e8aa54&scoped=true
// module id = MzTf
// module chunks = 0